import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

async function resendInvitation(userId: string): Promise<void> {
  const [response, bodyOrError] = await Api.post(`users/${userId}/resend-invitation`);
  if (!response.ok) throw bodyOrError;
}

export const useResendInvitation = () => {
  const client = useQueryClient();
  return useMutation('resendInvitation', resendInvitation, {
    onSuccess: (_data, userId) => client.invalidateQueries(['getUser', userId]),
  });
};
